import { router } from '@inertiajs/react';
import ReviewActivity from '../../../../components/vocabulary/review/ReviewActivity';

export default function ReviewShow(props) {
  const csrfToken =
    typeof document !== 'undefined'
      ? document.querySelector('meta[name="csrf-token"]')?.content
      : '';

  const handlePause = async () => {
    try {
      await fetch(`/student/vocabulary/review_sessions/${props.session_id}/pause`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          Accept: 'application/json',
        },
      });
    } catch (e) {
      // Network blip — fall through to navigation anyway. Worst case the
      // session doesn't surface as resumable on the dictionary CTA.
    }
    router.visit('/student/dictionary');
  };

  const handleDone = () => router.visit('/student/dictionary');

  return <ReviewActivity {...props} onPause={handlePause} onDone={handleDone} />;
}
